export default __webpack_public_path__ + "static/media/tab_7.3fd1ebba.png";